/**
 * @generated SignedSource<<b63c5c1bb2388ba01c0f335df08966f1>>
 * @relayHash 55f887ce338962f3d231967eb05baaf5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f5f3ec7358095a4d557e0d2edf4c5f6fa4971b5401acfcdacb83cc07f551b55a

import type { ConcreteRequest } from 'relay-runtime';
export type UserAndGroupSearchPickerQuery$variables = Record<PropertyKey, never>;
export type UserAndGroupSearchPickerQuery$data = {
  readonly entitlements: {
    readonly externalCollaborator: {
      readonly isEntitled: boolean;
    };
  } | null;
};
export type UserAndGroupSearchPickerQuery = {
  response: UserAndGroupSearchPickerQuery$data;
  variables: UserAndGroupSearchPickerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "concreteType": "Entitlements",
    "kind": "LinkedField",
    "name": "entitlements",
    "plural": false,
    "selections": [
      {
        "concreteType": "ExternalCollaboratorFeature",
        "kind": "LinkedField",
        "name": "externalCollaborator",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "isEntitled"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "UserAndGroupSearchPickerQuery",
    "selections": (v0/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "UserAndGroupSearchPickerQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "55f887ce338962f3d231967eb05baaf5",
    "id": "f5f3ec7358095a4d557e0d2edf4c5f6fa4971b5401acfcdacb83cc07f551b55a",
    "metadata": {},
    "name": "UserAndGroupSearchPickerQuery",
    "operationKind": "query",
    "text": "query UserAndGroupSearchPickerQuery{entitlements{externalCollaborator{isEntitled}}}"
  }
};
})();

(node as any).hash = "6fe67cddff8056d8e38840c5214712ee";

export default node;
